import SpecialJournals from "../js/components/settlements/SpecialJournals.react";

export default SpecialJournals;
